export const rollDie = (max = 6) => {
  return 1 + Math.floor(Math.random() * max);
};
